import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'

export const Wrapper = styled(Box)`
    border-bottom: 2px solid ${({ theme }) => theme.colors.grayscale_300};
    ${({ theme }) => {
        if (theme.mode === 'dark') {
            return css`
                border-color: #858dad;
            `
        }
    }};
`
